import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "body m-0 mb-1" }

import { useI18n } from 'vue-i18n'

  // Props
  
export default /*@__PURE__*/_defineComponent({
  __name: 'IresaReference',
  props: {
    reference: {
      type: String,
      required: true,
    },
  },
  setup(__props) {

  

  // i18n instance
  const { t } = useI18n()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("p", _hoisted_1, [
    _createElementVNode("strong", null, _toDisplayString(_unref(t)('reservations.reference')) + ":", 1),
    _createTextVNode(" " + _toDisplayString(__props.reference), 1)
  ]))
}
}

})